import { useSyncExternalStore } from 'react';

import { IDataStreamConsumer } from 'core/utils';

export function useDataStream<T>(stream: IDataStreamConsumer<T>) {
  return useSyncExternalStore(stream.subscribe, stream.getCurrentValue);
}
